import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../../_metronic/layout/core';
import ExpenseByCategory from '../ExpenseByCategory';
import ExpenseDetail from '../ExpenseDetail';
import ExpenseSummary from '../ExpenseSummary';
import ReportAnalyticsPage from './ReportAnalyticsPage';
import ExpenseViolationReport from '../ExpenseViolationReport';
import { useAppSelector } from '../../../../hooks';
import { selectAuth } from '../../../../features/authSlice';
import { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import CategoryBudgetReport from '../CategoryBudgetReport';
import { allRoutes } from '../../../routing/All_Routes';




const MyReportPage = () => {
    const { roleID } = useAppSelector(selectAuth)
    const [show, setShow] = useState(true);

    useEffect(() => {
        if (!show) return;
        const timer = setTimeout(() => {
            setShow(false);
        }, 5000);
        return () => clearTimeout(timer);
    }, [show]);

    const myReportBreadCrumbs: Array<PageLink> = [
        ...(roleID !== 5
            ? [{
                title: 'Analytics',
                path: `${allRoutes.analytics}/my-report/expense-summary`,
                isSeparator: false,
                isActive: true,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },]
            : []
        ),

        {
            title: 'My-Reports',
            path: `${allRoutes.analytics}/my-report/expense-summary`,
            isSeparator: false,
            isActive: true,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: false,
            isActive: false,
        },
    ]
    return (
        <div className='ss-analytics-report-wrapper'>
            <Routes>
                <Route
                    element={
                        <>
                            {show &&
                                <Alert variant="primary" onClose={() => setShow(false)} dismissible className="mb-2 py-2 d-flex align-items-center">
                                    <p className='mb-0 fs-7'>By default, data is displayed from the last 7 days.</p>
                                </Alert>}
                            <ReportAnalyticsPage />
                            <Outlet />
                        </>
                    }
                >
                    <Route
                        path='expense-summary'
                        element={
                            <>
                                <PageTitle breadcrumbs={myReportBreadCrumbs}>Expense Summary</PageTitle>
                                <ExpenseSummary />
                            </>
                        }
                    />
                    <Route
                        path='expense-detail'
                        element={
                            <>
                                <PageTitle breadcrumbs={myReportBreadCrumbs}>Expense Details</PageTitle>
                                <ExpenseDetail />
                            </>
                        }
                    />
                    <Route
                        path='expense-by-category'
                        element={
                            <>
                                <PageTitle breadcrumbs={myReportBreadCrumbs}>Expense Categories</PageTitle>
                                <ExpenseByCategory />
                            </>
                        }
                    />
                    <Route
                        path='expense-violations'
                        element={
                            <>
                                <PageTitle breadcrumbs={myReportBreadCrumbs}>Expense Violations</PageTitle>
                                <ExpenseViolationReport />
                            </>
                        }
                    />
                    <Route
                        path='category-budget'
                        element={
                            <>
                                <PageTitle breadcrumbs={myReportBreadCrumbs}>Category Budget</PageTitle>
                                <CategoryBudgetReport />
                            </>
                        }
                    />
                    <Route index element={<Navigate to={`${allRoutes.analytics}/my-report/expense-summary`} />} />

                </Route>
            </Routes>
        </div>
    );
};

export default MyReportPage;
